/* start - flights_split_bounds_us */
import { EditIcon, ArrowNavRightIcon } from "@bookingcom/bui-assets-react/streamline";
import { Stack, Icon, Text, Link } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { getUpdatedSearchParams } from "hooks/useSearchFilters";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getFiltersDraftOutbound } from "store/search/selectors";
import flights_split_bounds_us from "utils/experiments/funnel/flights_split_bounds_us";

const BackToOutbound = () => {
  const i18n = useI18n();
  const params = useParams<{ airports: string }>();
  const history = useHistory();
  const outboundFilters = useSelector(getFiltersDraftOutbound);

  const url = `/flights/${params?.airports}/outbound/?${getUpdatedSearchParams(outboundFilters).toString()}`;

  const onLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    flights_split_bounds_us.goals.change_depart_flight_click();
    history.push(url);
  };

  return (
    <Stack direction="row" alignItems="center">
      <Text variant="strong_2">
        <Link
          text={i18n.trans(t("flights_sr_split_bounds_us_change_departing"))}
          icon={EditIcon}
          iconPosition="start"
          href={url}
          onClick={onLinkClick}
        />
      </Text>
      <Icon svg={ArrowNavRightIcon} size="medium" />
      <Text variant="strong_2">{i18n.trans(t("flights_sr_split_bounds_us_select_returning"))}</Text>
    </Stack>
  );
};

export default BackToOutbound;
/* end - flights_split_bounds_us */
